import React from 'react'
import styled from '@emotion/styled'

import { grayDark40, grayLight20, fontWeightBold, fontSize3XSmall, fontSizeXSmall } from '../../constants/principles'
import { BrowserUtils } from '../../utils/siteUtils'
import { FlexDiv } from '../generic/Basics'
import Options from './Options'
import Color from './sections/Colors'
import Drivetrain from './sections/Drivetrain'
import Engine from './sections/Engine'
import InfoImage from './sections/InfoImage'
import VehicleModifications from './sections/VehicleModifications'
import TwoMoreKeysQuestion from './sections/TwoMoreKeysQuestion'
import Transmission from './sections/Transmission'

const sections = { Options, Color, Engine, Transmission, Drivetrain, InfoImage, TwoMoreKeysQuestion, VehicleModifications }

export default ({ displayOrder, disabledArray, singleOption, experienceState, vin, isIneligible, vehicleErrors, isError, ...props }) => {
  const isDesktop = BrowserUtils.isDesktop()
  return (
    <>
      {displayOrder.map((item, index) => {
        const Component = sections[item.component]
        const isDisabled = disabledArray.reduce((acc, cur, ind) => (ind <= index ? acc || cur : acc), false)

        return (
          item.displayProp() && (
            <SpecDiv data-testid={`vd-section-${item.component.toLowerCase()}`} key={index} isDesktop={isDesktop} isDisabled={isDisabled}>
              <TextWithSubheaderDiv fontWeight={fontWeightBold}>{item.title}</TextWithSubheaderDiv>
              <TextDiv fontSize={fontSize3XSmall} fontWeight="normal">
                {item.subtitle}
              </TextDiv>
              <Component
                {...experienceState}
                {...{ ...props, singleOption, vin }}
                isDisabled={process.env.BUILD_STAGE === 'build-html' || isDisabled}
                isError={isError && (vehicleErrors[item.component.toLowerCase()] || item.error)}
                isIneligible={isIneligible}
                isDesktop={isDesktop}
              />
            </SpecDiv>
          )
        )
      })}
    </>
  )
}

const TextDiv = styled.div`
  font-size: ${p => p.fontSize};
  font-weight: ${p => p.fontWeight};
  color: ${p => p.fontColor};
  padding-bottom: 16px;
`
const TextWithSubheaderDiv = styled(TextDiv)`
  padding-bottom: 0;
  width: 100%;
  text-align: center;
  background-color: white;
`
// 24 px on large viewports, 20 on small
const SpecDiv = styled(FlexDiv)`
  padding-top: 32px;
  padding-bottom: 32px;
  font-size: ${fontSizeXSmall};
  color: ${grayDark40};
  border-bottom: 1px solid ${grayLight20};
  width: ${p => (p.isDesktop ? 80 : 100)}%;
  margin: auto;
  &:last-child {
    border-style: none;
  }
  ${p =>
    p.isDisabled &&
    `
  cursor: not-allowed;
  opacity: .5;`}
`
